import React, { useState } from "react";
import { subYears } from "date-fns";
import { StepProps } from "../../types";
import { useWebTranslation } from "translations";
import ChatMessage, { ChatContainer } from "ui-kit/ChatMessage/ChatMessage";
import { Typography } from "ui-kit/Typography";
import Gutter from "ui-kit/Gutter";
import DateInput from "components/DateInput/DateInput";
import FlowButtons from "components/Signup/components/FlowButtons/FlowButtons";
import { useSignupDispatch } from "components/Signup/store/hooks";
import { updateCustomer } from "components/Signup/store/slices/customer";
import { useCustomer } from "components/Signup/store/selectors/customer";

const UserBirthdate = ({
  previous,
  next,
  isValid,
  transitioning,
}: StepProps) => {
  const { t } = useWebTranslation();
  const [dateValid, setDateValid] = useState(true);
  const [dateValidMin, setDateValidMin] = useState(true);
  const [dateValidMax, setDateValidMax] = useState(true);

  const minAge = subYears(new Date(), 120);
  const maxAge = subYears(new Date(), 18);

  const dispatch = useSignupDispatch();
  const { birthdate } = useCustomer();

  return (
    <ChatContainer leaving={transitioning}>
      <ChatMessage>
        <Typography>{t("signup.user_birthdate.text")}</Typography>
      </ChatMessage>
      <Gutter size={2} />
      <ChatMessage fromMe small>
        <DateInput
          ariaLabel={t("global.birthdate")}
          border={false}
          value={birthdate ?? ""}
          onChange={({ date, validation }) => {
            if (!dateValid) {
              setDateValid(validation.isValid);
            }
            setDateValidMin(validation.isValidMin);
            setDateValidMax(validation.isValidMax);

            dispatch(updateCustomer({ birthdate: date }));
          }}
          onBlur={({ validation }) => {
            setDateValid(validation.isValid);
          }}
          min={minAge}
          max={maxAge}
          noValidate
          autoComplete="bday"
          ariaDescribedBy="date-error"
        />
      </ChatMessage>
      {!(dateValid && dateValidMin) && (
        <div id="date-error" aria-live="assertive">
          <Gutter size={1} />
          <Typography color={"error"} testId="date-error">
            {t("date_input.error")}
          </Typography>
          <Gutter size={1} />
        </div>
      )}
      {!dateValidMax && (
        <div id="date-error" aria-live="assertive">
          <Gutter size={1} />
          <Typography color={"error"}>
            {t("validation.underage_person")}
          </Typography>
          <Gutter size={1} />
        </div>
      )}
      <FlowButtons
        inProgress={transitioning}
        backButton={false}
        next={next}
        disabled={!isValid}
        previous={previous}
      />
    </ChatContainer>
  );
};

export default UserBirthdate;
